// extracted by mini-css-extract-plugin
module.exports = {"link":"ContactSales-module__link___2ln4Z"};